﻿/**
 * portal.directive
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add directive */
	angular.module('nha.portal').directive('portal', portalDirective);

	/** injection */
	portalDirective.$inject = ['appSettings'];

	/** implementation */
	function portalDirective(appSettings) {
		/** return directive */
		return {
			restrict: 'E',
			templateUrl: 'app/portal/portal.directive.html',
			scope: {},
			link: linkFunc
		};

		/** link function */
		function linkFunc(scope) {
			/** set the moduleID */
			scope.settingKey = appSettings.moduleSettingKey;
		}
	}
})();